import styled from 'styled-components';

export const StyledNavigationBar = styled.nav`
  background-color: ${props => props.theme.colors.get(props.variant)};
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  padding: ${props => props.theme.spacing(2, 5)};
  position: relative;
  @media ${props => props.theme.tablet} {
    padding: ${props => props.theme.spacing(4, 10)};
  }
  @media ${props => props.theme.laptopL} {
    padding: ${props => props.theme.spacing(4, 20)};
  }
`;

export const SkipToContent = styled.a`
  position: absolute;
  left: 0;
  color: ${props => props.theme.colors.text.primary};
  transform: translateX(-110%);
  transition: transform 0.3s;
  padding: 2px 5px;

  &:focus {
    transform: translateY(0%);
  }
`;

export const OllieLogo = styled.div`
  display: flex;
  justify-content: center;
`;

export const LogoImg = styled.img`
  height: 100%;
  max-height: 40px;
`;

export const LeftAligned = styled.div`
  display: flex;
  flex: 1;
  justify-content: left;
`;

export const RightAligned = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
`;

export const GetStartedButton = styled.div`
  display: none;
  margin-right: 8px;
  @media ${props => props.theme.tablet} {
    display: block;
  }
`;

export const MobileCtaButton = styled.div`
  display: block;
`;

export const DesktopNavigationMenu = styled.div`
  display: none;
  @media ${props => props.theme.laptop} {
    display: flex;
  }
`;

export const MobileNavigationMenu = styled.div`
  display: flex;
  @media ${props => props.theme.laptop} {
    display: none;
  }
`;

export const MobileCtaButtonContainer = styled.div`
  position: absolute;
  width: 100%;
  bottom: ${props => props.theme.spacing(10)};
  padding: 0 ${props => props.theme.spacing(3)} 0
    ${props => props.theme.spacing(3)};
`;

export const MobileCtaMemberButtonContainer = styled.div`
  width: 100%;
`;

export const MobileButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${props => props.theme.spacing(props.verticalMargin, 0)};
`;

export const BurgerMenu = styled.button`
  background: none;
  border: none;
  display: flex;
  align-items: center;
`;

export const SlideOutMenu = styled.div`
  color: ${props => props.theme.colors.text.primary};
  ${props => props.theme.typography.heading1};
  display: flex;
  flex-direction: column;
  text-align: center;
  letter-spacing: 0.01em;
`;

export const LogoLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  &:focus {
    outline: 1px solid ${props => props.theme.colors.text.primary};
    border-radius: 2px;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export const StyledStepCounter = styled.div`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.secondary};
`;
